import { FinanceType } from 'src/utils/enums/financialTypes.enum';
import { QuickFundMessageEnum } from 'src/utils/enums/quickFund.enum';

export enum CreditSearchTypes {
    STATUS = 'STATUS',
    APPLICANT_NAME = 'APPLICANT_NAME',
    APPLICATION_NUMBER = 'APPLICATION_NUMBER',
    RECEIVED_IN_MONTHS = 'RECEIVED_IN_MONTHS',
    SSN = 'SSN',
}

export enum CreditApplicationStatus {
    CONDITIONED = 'Conditioned',
    PENDING = 'Pending',
    APPROVED = 'Approved',
    WITHDRAWN = 'Withdrawn',
    DECLINED = 'Declined',
    BOOKED = 'Booked',
    OTHERTYPE = 'OtherType',
}

export enum CreditSearchStatusOptionsState {
    Approved = 'StatusSummary.Label.Item.Approved',
    Pending = 'StatusSummary.Label.Item.Pending',
    Declined = 'StatusSummary.Label.Item.Declined',
    Conditioned = 'StatusSummary.Label.Item.Conditioned',
    Withdrawn = 'StatusSummary.Label.Item.Withdrawn',
    AllStatutes = 'CreditSearch.Table.Option.Status.All',
}

export interface ICreditStatusObject {
    id: string;
    creditApplication: any;
    losStatus: number;
    status: CreditApplicationStatus;
    applicationNumber: number;
    applicantFirstName: string;
    applicantLastName: string;
    dealerId: string;
    businessName: string;
    phoneNumber: string;
    vehicleDescription: string;
    sourceSystem: string;
    submittedBy: string;
    ssn: string;
    ssnCoApplicant: string;
    createdBy: string;
    createdTime: string;
    modifiedBy: string;
    modifiedTime: string;
    submittedTime: string;
    dmsDealerNumber: string;
    errorMessage: string;
    resubmitCount: number;
    initialCreditTier: string;
    collegeGradComment: string;
    showEditButton: boolean;
    quickfundData?: {
        isEligible: boolean;
        isFunded: boolean;
        reasonMessage: QuickFundMessageEnum;
        quickFund?: QuickFund;
        hasValidatedContract?: boolean;
        disableQuickFundEntry: boolean;
        showContinueButton: boolean;
        showSubmitButton: boolean;
        showSecurityDepositNode: boolean;
        toggleDeductionAmountFieldEntry: boolean;
        continueInstructionMessage: string;
    };
}

export interface CreditStatusTableData {
    key: string;
    name: string;
    applicationNumber: number;
    status: CreditApplicationStatus;
    collateral: string;
    submittedBy: string;
    submittedTime: string;
    sourceSystem: string;
}
export interface QuickFund {
    Key: number;
    AcquisitionFee: number;
    AdjustedCapCost: number;
    AdvanceAmount: number;
    SubmittedDate: string;
    Vin: string;
    AccountNumber: string;
    SubmittedBy: string;
    AmountToFinance: number;
    BulletinNumber?: string;
    ContractValidationNumber?: string;
    MonthlyPayment?: number;
    SecurityDeposit?: number;
    NetProceedsAmount?: number;
    FinanceType?: FinanceType;
    ApplicationId?: string;
}

export interface ISaveQuickFundRequest {
    correlationId?: string;
    dealerId: string;
    country: string;
    partyId: number | string;
    firstName: string;
    lastName: string;
    quickFund: Pick<QuickFund, 'AdvanceAmount' | 'AccountNumber'> &
        Partial<
            Omit<
                Pick<
                    QuickFund,
                    | 'Key'
                    | 'AcquisitionFee'
                    | 'AdjustedCapCost'
                    | 'SubmittedDate'
                    | 'Vin'
                    | 'SubmittedBy'
                    | 'AmountToFinance'
                    | 'MonthlyPayment'
                    | 'SecurityDeposit'
                    | 'FinanceType'
                >,
                'FinanceType'
            >
        > & { FinanceType?: number };
    jwtToken?: string;
}
